import React from 'react'
import { SearchDropdown } from '@ui'
import { IWorkplaceGroupTableRecord } from '@api'
import useWorkplaceGroupSearch from './hooks/useWorkplaceGroupSearch'
import { WorkplaceItem } from './Catalog/WorkplaceGroupCatalog'
import track from '@track'
import Event from '@track/Event'

export default function WorkplaceGroupSearch({
  navigate,
  queryTable,
}: {
  navigate?: (to: string) => void
  queryTable: (query: string) => void
}) {
  const search = useWorkplaceGroupSearch()
  const onSelect = (workplaceGroup: IWorkplaceGroupTableRecord) => {
    navigate?.(`?workplaceGroupId=${workplaceGroup.id}`)
    track.workplaceGroups({
      eventName: Event.SEARCH_RESULT_CLICK,
    })
  }

  return (
    <SearchDropdown
      {...{
        'data-input': 'workplace_group_search',
        search,
        queryTable,
        onSelect,
        width: '400px',
      }}
      renderItem={(workplaceGroup: IWorkplaceGroupTableRecord) => (
        <WorkplaceItem
          name={workplaceGroup.name}
          color={workplaceGroup.color}
          search={search.query}
        />
      )}
    />
  )
}
